import { render, staticRenderFns } from "./ui-hourglass.vue?vue&type=template&id=2ef0934f&scoped=true&"
import script from "./ui-hourglass.vue?vue&type=script&lang=js&"
export * from "./ui-hourglass.vue?vue&type=script&lang=js&"
import style0 from "./ui-hourglass.vue?vue&type=style&index=0&id=2ef0934f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef0934f",
  null
  
)

export default component.exports